import React, { useState } from "react";

import FormAction from "../../../components/common/FormAction";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import Footer from "../../../components/common/Footer";
import qr_code from "../../../assets/images/qr-code.png";

import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-hot-toast";
import { copyImageToClipboard } from "copy-image-clipboard";
import { saveAs } from "file-saver";

import { Button, Card, Checkbox, Col, Form, Input, Radio, Row, Select, Space } from "antd";
import { HiOutlineHashtag } from "react-icons/hi";


import "./OnlinePostingSettings.css";

const RentalApplicationsFeesRightBar = [];
const options = [
  { value: "Most Recent" },
  { value: "Rent (Low to High)" },
  { value: "Rent (High to Low)" },
  { value: "Bedrooms" },
];

function OnlinePostingSettings() {
  const [innerCheckBoxShow, setInnerCheckBoxShow] = useState(false);
  const [color, setColor] = useState("676767");
  const [copied, setCopied] = useState(false);

  const downloadImage = () => {
    try {
      saveAs(qr_code, "qrcode.png");
      toast.success("Downloaded Successfully");
    } catch (err) {
      toast.error(err.message);
    }
  };

  const copyImage = () => {
    copyImageToClipboard(qr_code)
      .then(() => {
        toast.success("Image Copied");
      })
      .catch((e) => {
        toast.error(e.message);
      });
  };

  const copyText = () => {
    try {
      setCopied(true);
      toast.success("HTML Code Copied");
      console.log(copied);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const text = `<script type='text/javascript' charset='utf-8'>
  document.write(unescape("%3Cscript src='" + (('https:' == document.location.protocol) ? 'https:' : 'http:') + 
  "//integrityoklahoma.appfolio.com/javascripts/listing.js' type='text/javascript'%3E%3C/script%3E"));
</script>

<script type='text/javascript' charset='utf-8'>
  Appfolio.Listing({
    hostUrl: 'integrityoklahoma.appfolio.com',
    //propertyGroup: 'My Group Name',
    themeColor: '#${color}',
    height: '500px',
    width: '100%',
    defaultOrder: 'rent_asc'
  });
</script>`;

  return (
    <>
      <div className="page-container">
        <div className="online-posting-container main-container">
          <PageHeading heading="Online Posting Settings" />
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <Form>
                <Form.Item>
                  <Checkbox>
                    Allow prospective tenants to submit guest cards from website
                    listings
                  </Checkbox>
                </Form.Item>
                <Form.Item>
                  <Checkbox
                    onChange={() => setInnerCheckBoxShow(!innerCheckBoxShow)}
                  >
                    Enable online applications and sending applications to guest
                    cards
                  </Checkbox>
                </Form.Item>
                {innerCheckBoxShow ? (
                  <Form.Item>
                    <Checkbox className="inner-checkbox">
                      Enable online applications and sending applications to
                      guest cards
                    </Checkbox>
                  </Form.Item>
                ) : null}
                <Form.Item>
                  <Checkbox>
                    Allow vacancy posting contact information to be set on the
                    property page
                  </Checkbox>
                </Form.Item>
                <FormAction />
              </Form>
            </Col>
            <Col span={24}>
              <Card title="Vacancy Posting HTML Code">
                <Form
                  labelCol={{ span: 16 }}
                  wrapperCol={{ span: 4 }}
                  className="online-posting-form"
                >
                  <div className="fields-container">
                    <p className="common-paragraph">
                      To post vacancies to websites that are not hosted by
                      AppFolio, copy the following HTML code, then paste it onto
                      your website.
                    </p>
                    <Form.Item label="Choose the order for vacancy listings to appear on your site">
                      <Select initalvalues="Low to High" options={options} />
                    </Form.Item>
                    <Form.Item label='Enter a HEX Color value to customize the color of the header bar and "Apply Now" buttons'>
                      <Input
                        addonBefore={<HiOutlineHashtag size={14} />}
                        placeholder="676767"
                        allowClear
                        onChange={(e) => setColor(e.target.value)}
                      />
                    </Form.Item>
                    <p className="common-paragraph italic">
                      Note: Once this HTML code is embedded on your website,
                      units marked as "Posted to Website" will automatically
                      appear. It will take few minutes for changes made in
                      AppFolio to be reflected on your website.
                    </p>
                  </div>
                  <div className="html-code-container">
                    <pre>{text}</pre>
                  </div>
                  <CopyToClipboard text={text} onCopy={() => copyText()}>
                    <Button type="primary" className="copy-btn">
                      Copy HTML to Clipboard
                    </Button>
                  </CopyToClipboard>
                </Form>
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Vacancies QR Code">
                <div className="vacancies-qr-code">
                  <p className="common-paragraph">
                    Generate a QR code that can quickly link to the{" "}
                    <a
                      href="https://integrityoklahoma.appfolio.com/listings"
                      rel="noreferrer"
                      target="_blank"
                      className="onclick-text"
                    >
                      current "posted to website" listings online
                    </a>{" "}
                    when scanned with a smartphone camera.
                  </p>
                  <p className="common-paragraph">
                    Include the QR code on a flyer, newsletter, signage, and/or
                    display it in the window of a property or leasing office,
                    allowing prospective tenants to view the available units any
                    time.
                  </p>
                  <Form className="qr-form">
                    <Form.Item>
                      <Radio.Group>
                        <Space direction="vertical">
                          <Radio value={1}>All Properties</Radio>
                          <Radio value={2}>Property Group / Portfolio:</Radio>
                        </Space>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item>
                      <Select
                        initalvalues="Test Group"
                        style={{ display: "inline" }}
                      />
                    </Form.Item>
                  </Form>
                  <img src={qr_code} alt="qr-code" />
                  <div className="buttons-container">
                    <Button type="primary" onClick={() => copyImage()}>
                      Copy QR Image to Clipboard
                    </Button>
                    <Button type="primary" onClick={() => downloadImage()}>
                      Download QR Image .png
                    </Button>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
          <Footer />
        </div>
      </div>
      <div className="RightSideBar">
        <RightBar RightBarData={RentalApplicationsFeesRightBar} />
      </div>
    </>
  );
}

export default OnlinePostingSettings;
